import React from 'react';
import { Dialog, IconButton, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClinicalIntelligence from 'careiq/ui/clinicalintelligence';

const ClinicalShareModal = ({ open, onClose, data }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md" // You can use 'md' or 'xl' if preferred
      PaperProps={{ style: { backgroundColor: '#f9fafb', borderRadius: '8px' } }}
    >
      <div className="p-4 flex justify-between items-center bg-white border-b">
        <h2 className="text-xl font-semibold text-blue-800">Clinical Intelligence Share View</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers className="p-4">
        <div className="max-w-6xl mx-auto">
          <ClinicalIntelligence view={1} data={data} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClinicalShareModal;
